<template>
  <div class="wrap talk">
    <div class="container">
      <main class="content" style="height: 100vh; overflow: scroll;">
        <article v-if="!isModal" class="main">
          <QuickLink />
        </article>
        <article class="certification atm"
          :style="{
            'margin-top': '0.75rem',
            height: !isModal ? 'calc(100vh - 216px)' : '100%',
            overflow: 'scroll'
            }"
          >
          <section style="padding: 0 0.5rem">
            <div class="con-box" style="margin-top: 0; overflow: auto;">
              <h2>ATM 정보<span>정기 유지보수 결과를 입력해주세요.</span></h2>
              <div class="form-wrap">
                <dl class="row row_jsb row_ac">
                  <dt>
                    {{ isConnectedAtm ? "COM 번호" : "ATM 찾기" }}
                  </dt>
                  <dd :class="isConnectedAtm ? '' : 'width50'">
                    <input
                      type="text"
                      class="t-input"
                      :readonly="isConnectedAtm"
                      placeholder="COM 번호를 입력하세요"
                      v-model="getStoreAtmInfo.com_num"
                    />
                  </dd>
                  <dd v-if="!isConnectedAtm" class="btn-wrap">
                    <a class="btn bg-default" @click="findAtmInfo">찾기</a>
                  </dd>
                </dl>
                <div class="info-inp">
                  <input
                    type="text"
                    class="t-input"
                    v-model="mntcData.atmInfo"
                    disabled
                  />
                </div>
                <dl class="row row_jsb row_ac">
                  <dt>
                    <span class="icon_require point"/>
                    등록일시
                  </dt>
                  <dd>
                    <div class="input-area">
                      <div class="wp100">
                        <DxDateBox
                          v-model="mntcData.regDt"
                          class="wp100"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          styling-mode="outlined"
                        />
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>
                    특이사항 유형
                  </dt>
                  <dd>
                    <div class="input-area">
                      <div class="label-check wp100">
                        <DxSelectBox
                          :dataSource="atmMntcPecuCdList"
                          displayExpr="cmnsCdNm"
                          valueExpr="cmnsCd"
                          height="30px"
                          placeholder="선택하세요."
                          v-model="mntcData.atmMntcPecuCd"
                        />
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>( {{ mntcData.atmMntcPecuCtts.length }} / 200)</dt>
                  <dd class="h-textarea">
                    <textarea
                      id="atmMntcPecuCtts"
                      cols="30"
                      rows="10"
                      class="textBox h-100"
                      style="line-height: 15px !important; height: 60px; resize: none;"
                      v-model="mntcData.atmMntcPecuCtts"
                    />
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>
                    <span class="icon_require point"/>
                    ATM상세위치
                  </dt>
                  <dd>
                    <div class="input-area">
                      <div class="label-check wp100">
                        <DxSelectBox
                          :dataSource="atmMntcDtlLocList"
                          displayExpr="cmnsCdNm"
                          valueExpr="cmnsCd"
                          height="30px"
                          placeholder="선택하세요."
                          v-model="mntcData.atmMntcDtlLoc"
                        />
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>( {{ mntcData.atmMntcDtlLocCtts.length }} / 200)</dt>
                  <dd class="h-textarea">
                    <textarea
                      id="atmMntcDtlLocCtts"
                      cols="30"
                      rows="10"
                      class="textBox h-100"
                      style="line-height: 15px !important; height: 60px; resize: none;"
                      v-model="mntcData.atmMntcDtlLocCtts"
                    />
                  </dd>
                </dl>
                <template v-if="false && 'BOSA-121'">
                  <dl class="row row_jsb row_ac">
                    <dt>외관</dt>
                    <dd>
                      <div class="input-area">
                        <div class="label-check">
                          <RadioCodeListType3
                            name="extlChckStatCd"
                            cmnsCdGrpId="ATM_MNTC_EXTL_CD"
                            :value="mntcData.extlChckStatCd"
                            @input="
                              value =>
                                handleExtlChckStatCd(value, 'extlChckStatCd')
                            "
                          />
                        </div>
                      </div>
                    </dd>
                  </dl>
                  <dl class="row row_jsb row_ac">
                    <dt>촬영함</dt>
                    <dd>
                      <div class="input-area">
                        <div class="label-check">
                          <RadioCodeListType3
                            name="cmraExtlChckStatCd"
                            cmnsCdGrpId="ATM_MNTC_EXTL_CD"
                            :value="mntcData.cmraExtlChckStatCd"
                            @input="
                              value =>
                                handleExtlChckStatCd(value, 'cmraExtlChckStatCd')
                            "
                          />
                        </div>
                      </div>
                    </dd>
                  </dl>
                  <dl class="row row_jsb row_ac mb_30">
                    <dt>케이블</dt>
                    <dd>
                      <div class="input-area">
                        <div class="label-check n5">
                          <label>
                            <input
                              type="checkbox"
                              v-model="mntcData.cablChckStatCd"
                              @change="onChangeCable"
                            />
                            <span>정상</span>
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              v-model="mntcData.cb5pChckStatCd"
                              @change="onChange5pCable"
                            />
                            <span>5핀</span>
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              v-model="mntcData.cb8pChckStatCd"
                              @change="onChange8pCable"
                            />
                            <span>8핀</span>
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              v-model="mntcData.cbctChckStatCd"
                              @change="onChangecCable"
                            />
                            <span>C-Type</span>
                          </label>
                        </div>
                      </div>
                    </dd>
                  </dl>
                  <dl class="row row_jsb row_ac">
                    <dt>바코드용지</dt>
                    <dd>
                      <div class="label-check n6">
                        <label>
                          <input
                            type="radio"
                            value="1"
                            v-model="mntcData.brcdStatCd"
                          />
                          <span>교체</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="2"
                            v-model="mntcData.brcdStatCd"
                          />
                          <span>30%이상</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="3"
                            v-model="mntcData.brcdStatCd"
                          />
                          <span>고장</span>
                        </label>
                      </div>
                    </dd>
                  </dl>
                  <dl class="row row_jsb row_ac">
                    <dt>특이사항</dt>
                    <dd>
                      <input
                        type="text"
                        class="t-input"
                        placeholder="특이사항 메모해주세요"
                        v-model="mntcData.spntCtts"
                      />
                    </dd>
                  </dl>
                </template>
                <dl class="row row_jsb row_ac">
                  <dt>외관 이미지</dt>
                  <dd class="h-textarea" @click="mntcImgFileInputClick">
                    <button type="button" class="btn-file" style="position: relative; z-index: 1; top: 2px">파일선택</button>
                    <textarea
                      id="atmMntcFileNameList"
                      cols="30"
                      rows="10"
                      class="textBox h-100"
                      readonly
                      style="line-height: 15px !important; height: 60px; resize: none; position: relative; top: -22px;"
                      v-model="getMntcFileNameList"
                    />
                  </dd>
                </dl>
              </div>
            </div>
          </section>
          <div class="btn-wrap" style="position: sticky; bottom: 0; background-color: #f8fbfa;">
            <a class="talk-btn btn-black" @click="mntcSave">유지보수저장</a>
          </div>
          <section v-if="false && 'BOSA-121'">
            <div class="con-box">
              <h2>ATM 이상신고<span>장애내용을 등록해주세요.</span></h2>
              <div class="form-wrap">
                <dl class="row row_jsb row_ac">
                  <dt>장애유형</dt>
                  <dd>
                    <select class="t-select" v-model="obstData.atmObstTypeCd">
                      <option value="">전체</option>
                      <option
                        v-for="atmObstType in atmObstTypeCds"
                        :key="atmObstType.code"
                        :value="atmObstType.cmnsCd"
                      >
                        {{ atmObstType.cmnsCdNm }}
                      </option>
                    </select>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>ATM상태</dt>
                  <dd>
                    <input
                      type="text"
                      class="t-input"
                      v-model="obstData.atmObstStatCd"
                      disabled
                    />
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>내용</dt>
                  <dd class="h-textarea">
                    <textarea
                      cols="30"
                      rows="10"
                      class="textBox h-100"
                      v-model="obstData.atmObstCtts"
                    ></textarea>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>첨부 이미지</dt>
                  <dd class="t-input addfile">
                    <input
                      type="file"
                      placeholder=""
                      accept="image/*"
                      capture="camera"
                      @change="onObstFileChange"
                    />{{ obstData.obstFileNm
                    }}<button type="button" class="btn-file">파일선택</button>
                  </dd>
                </dl>
              </div>
            </div>
            <div class="btn-wrap">
              <a class="regist-btn btn-black" @click="obstSave">장애신고</a>
              <a class="regist-btn btn-black" @click="mntcObstSave"
                >유지보수/장애 일괄등록</a
              >
              <a class="list-btn btn-black" @click="gotoatmMntcHstr">리스트</a>
            </div>
          </section>
        </article>
      </main>
    </div>
    <Camera @popupComplete="cameraJobDone"/>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import AppConfig from '@/config'
import {mapGetters} from 'vuex'
import isEmpty from 'lodash/isEmpty'

import QuickLink from '@/components/QuickLink.vue'
import RadioCodeListType3 from '@/components/RadioCodeListType3.vue'
import Camera from '@/components/Camera.vue'
import DxDateBox from 'devextreme-vue/date-box'
import DxSelectBox from 'devextreme-vue/select-box'

export default {
  name: 'AtmMntcHstrInsert',
  components: {
    QuickLink,
    RadioCodeListType3,
    Camera,
    DxDateBox,
    DxSelectBox
  },
  props: ['isModal'],
  data () {
    return {
      prefixUrl: '/api/purchase/customerCare/atmMntcHstrInsert',
      mntcData: {
        prchChnlAfliNum: '',
        atmInfo: '',
        atmNum: '',
        atmId: '',
        atmDvsnCd: '',
        atmMntcSchdNum: '',
        extlChckStatCd: '',
        cmraExtlChckStatCd: '',
        cablChckStatCd: false,
        cb5pChckStatCd: false,
        cb8pChckStatCd: false,
        cbctChckStatCd: false,
        mntcFileNameList: [],
        atmMntcPecuCd: '',
        atmMntcDtlLoc: '',
        regDt: moment().format('yyyy-MM-DD'),
        atmMntcPecuCtts: '',
        atmMntcDtlLocCtts: ''
      },
      obstData: {
        atmNum: '',
        atmStatCd: '',
        atmObstTypeCd: '',
        atmObstStatCd: '',
        atmObstRegCd: '2',
        atmObstCtts: '',
        obstFileNm: '',
        wrkwDvsnCd: '10'
      },
      atmObstTypeCds: [],
      mntcFiles: [],
      obstFile: null,
      isOpenModal: false,
      atmMntcPecuCdList: [],
      atmMntcDtlLocList: [],
      isShowAtmMntcPecuCtts: false,
      isShowAtmMntcDtlLocCtts: false
    }
  },
  computed: {
    ...mapGetters('Login', {
      userId: 'getUserId'
    }),
    ...mapGetters('LatestMenu', {
      latestMenuList: 'getLatestMenuList',
      current: 'getCurrent'
    }),
    getStoreAtmInfo () {
      return window.$store.getters['AtmWsStore/getResAtmInfo']
    },
    isConnectedAtm () {
      return !isEmpty(this.getStoreAtmInfo)
    },
    getMntcFileNameList () {
      return this.mntcData.mntcFileNameList.join('\n')
    }
  },
  watch: {
    '$route' (to, from) {
      // 초기화 작업
      if (to.name === 'AtmMntcHstrInsert') {
        this.init()
        const sai = this.getStoreAtmInfo
        if (sai) {
          this.mntcData = {
            ...this.mntcData,
            prchChnlAfliNum: sai.com_num
          }
          this.findAtmInfo()
        }
      }
    },
    getStoreAtmInfo (newVal, oldVal) {
      if (!isEmpty(newVal) && newVal !== oldVal) {
        const sai = this.getStoreAtmInfo
        this.mntcData = {
          ...this.mntcData,
          prchChnlAfliNum: sai.com_num
        }
        this.findAtmInfo()
      }
    },
    'mntcData.atmMntcPecuCd' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isShowAtmMntcPecuCtts = newVal === 'DR_WRT'
        if (!this.isShowAtmMntcPecuCtts) {
          this.mntcData.atmMntcPecuCtts = ''
        } else {
          setTimeout(() => {
            document.getElementById('atmMntcPecuCtts').focus()
          }, 100)
        }
      }
    },
    'mntcData.atmMntcDtlLoc' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isShowAtmMntcDtlLocCtts = newVal === '900'
        if (!this.isShowAtmMntcDtlLocCtts) {
          this.mntcData.atmMntcDtlLocCtts = ''
        } else {
          setTimeout(() => {
            document.getElementById('atmMntcDtlLocCtts').focus()
          }, 100)
        }
      }
    }
  },
  methods: {
    handleExtlChckStatCd (value, trgtDataName) {
      Object.assign(this.mntcData, { [trgtDataName]: value })
    },
    mntcImgFileInputClick () {
      this.$modal.show('cameraModal', { limitCnt: 5 })
    },
    onObstFileChange (e) {
      this.obstFile = e.target.files[0] || e.dataTransfer.files[0]
      this.obstData.obstFileNm = this.obstFile.name
    },
    onChangeCable (e) {
      if (this.mntcData.cablChckStatCd === true) {
        // 정상이면 다른 것은 해제
        this.mntcData.cb5pChckStatCd = false
        this.mntcData.cb8pChckStatCd = false
        this.mntcData.cbctChckStatCd = false
      }
    },
    onChange5pCable (e) {
      if (this.mntcData.cb5pChckStatCd === true) {
        // 5핀 체크시 정상은 해제
        this.mntcData.cablChckStatCd = false
      }
    },
    onChange8pCable (e) {
      if (this.mntcData.cb8pChckStatCd === true) {
        // 8핀 체크시 정상은 해제
        this.mntcData.cablChckStatCd = false
      }
    },
    onChangecCable (e) {
      if (this.mntcData.cbctChckStatCd === true) {
        // C-type 체크시 정상은 해제
        this.mntcData.cablChckStatCd = false
      }
    },
    waitForNextAction (timeToDelay) {
      return new Promise((resolve) => setTimeout(resolve, timeToDelay))
    },
    async findAtmInfo () {
      if (!this.mntcData.prchChnlAfliNum) {
        window.$Alert.alert('COM 번호를 입력하세요~')
        return
      }
      // 기존의 있는 값이 있지 않게 하기 위한 작업
      this.mntcData.atmNum = ''
      this.obstData.atmNum = ''

      if(!this.getStoreAtmInfo){      
        await Vue.httpClient.get('/api/purchase/customerCare/atmMntcHstrBsncnum', {params: { ...this.mntcData, workYymm: moment().format('yyyyMM') }})
          .then((response) => {
            if (response && response.data && response.data.result) {
              const prchChnlAfliObj = response.data.result
              this.mntcData = {
                ...this.mntcData,
                atmNum: prchChnlAfliObj.atmNum,
                atmId: prchChnlAfliObj.atmId,
                atmInfo: prchChnlAfliObj.atmInfo,
                atmDvsnCd: prchChnlAfliObj.atmDvsnCd,
                atmMntcSchdNum: prchChnlAfliObj.atmMntcSchdNum
              }
              this.obstData.atmNum = prchChnlAfliObj.atmNum
            }
          })
      }else{
        //ISSU-4765 분기처리로 개선
        this.mntcData = {
                ...this.mntcData,
                atmNum: this.getStoreAtmInfo.atm_num,
                atmId: this.getStoreAtmInfo.atm_id,
                atmInfo: this.getStoreAtmInfo.atm_num+this.getStoreAtmInfo.atm_id+this.getStoreAtmInfo.atm_name,
                atmDvsnCd: this.getStoreAtmInfo.atm_type,
                atmMntcSchdNum: this.getStoreAtmInfo.atm_mntc_schd_num
              }
              this.obstData.atmNum = this.getStoreAtmInfo.atm_num
      }

      if (this.mntcData.atmNum == null || this.mntcData.atmNum === '') {
        this.mntcData = {...this.mntcData, atmInfo: '', atmDvsnCd: ''}
        this.obstData = {...this.obstData, atmNum: '', atmObstStatCd: ''}
        window.$Alert.alert('COM 번호를 확인해 주세요!')
      } else {
        this.findAtmNumStat()
      }
    },
    async findAtmNumStat () {
      // ATM의 장애상태값 초기화 작업
      this.obstData.atmObstStatCd = ''
      this.obstData.atmNum = this.mntcData.atmNum
      // ATM의 상태값 조회
      await Vue.httpClient.get('/api/purchase/customerCare/selectAtmNumStatCheck', {params: { ...this.obstData }})
        .then((response) => {
          if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            const { atmObstStatCd, atmStatCd } = response.data.result[0]
            this.obstData = { ...this.obstData, atmObstStatCd, atmStatCd }
          }
        })
      // 구분자 값으로 민팃박스로 확인하여 저장하지 못하게 - 2021-12-06 요청사항임
      if (this.mntcData.atmDvsnCd === 5) {
        this.atmMntcButton = false
        window.$Alert.alert('민팃박스는 등록 할 수 없습니다.')
      } else {
        this.atmMntcButton = true
      }
    },
    async upload (uploadFiles) {
      const fd = new FormData()
      for (let uploadFile of uploadFiles) {
        fd.append('files', uploadFile)
      }
      const { data } = await Vue.httpClient.post('/api/purchase/customerCare/imageUpload',
        fd, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )

      if (data.status === '200') {
        return data.result
      } else {
        return ''
      }
    },
    mntcVaildationCheck () {
      if (this.mntcData.atmNum == null || this.mntcData.atmNum === '' || this.mntcData.prchChnlAfliNum == null || this.mntcData.prchChnlAfliNum === '') {
        window.$Alert.alert('COM 번호를 확인해 주세요.')
        return false
      }
      if (!this.mntcData.regDt) {
        window.$Alert.alert('등록일을 선택하세요.')
        return false
      }
      if (!this.mntcData.atmMntcPecuCd) {
        // window.$Alert.alert('특이사항 유형을 선택하세요.')
        // return false
      }
      if (!this.mntcData.atmMntcDtlLoc) {
        window.$Alert.alert('ATM상세위치를 선택하세요.')
        return false
      }
      if ((this.mntcData.cablChckStatCd == null || this.mntcData.cablChckStatCd === false) &&
          (this.mntcData.cb5pChckStatCd == null || this.mntcData.cb5pChckStatCd === false) &&
          (this.mntcData.cb8pChckStatCd == null || this.mntcData.cb8pChckStatCd === false) &&
          (this.mntcData.cbctChckStatCd == null || this.mntcData.cbctChckStatCd === false)) {
        // window.$Alert.alert('케이블을 선택하세요.')
        // return false
      }
      if (this.mntcData.brcdStatCd == null || this.mntcData.brcdStatCd === false) {
        // window.$Alert.alert('바코드를 선택하세요.')
        // return false
      }
      if (this.mntcData.atmMntcPecuCd === 'DR_WRT' && !this.mntcData.atmMntcPecuCtts.length) {
        window.$Alert.alert('특이사항을 직접 입력해 주세요.')
        return false
      }
      if (this.mntcData.atmMntcPecuCtts && this.mntcData.atmMntcPecuCtts.length > 200) {
        window.$Alert.alert('특이사항은 최대 200자 입니다.')
        return false
      }
      if (this.mntcData.atmMntcDtlLoc === '900' && !this.mntcData.atmMntcDtlLocCtts.length) {
        window.$Alert.alert('ATM 상세위치를 직접 입력해 주세요.')
        return false
      }
      if (this.mntcData.atmMntcDtlLocCtts && this.mntcData.atmMntcDtlLocCtts.length > 200) {
        window.$Alert.alert('ATM 상세위치는 최대 200자 입니다.')
        return false
      }
      if (this.mntcData.atmMntcPecuCd === 'BRER_ATCH' && (this.mntcFiles === '' || this.mntcFiles.length <= 0)) {
        window.$Alert.alert('이미지를 등록해주세요.')
        return false
      }

      return true
    },
    async mntcSave () {
      if (!this.mntcVaildationCheck()) return

      const confirm = await this.$Alert.confirm('저장 하시겠습니까?')
      if (!confirm) return

      if (this.mntcFiles && this.mntcFiles.length > 0) {
        const tempFileNameList = `${await this.upload(this.mntcFiles)}`
        if (tempFileNameList.includes('/%/')) {
          this.mntcData.mntcFileNameList = tempFileNameList.split('/%/').map(fileName => fileName)
        }else{
          this.mntcData.mntcFileNameList = (Array.isArray(tempFileNameList) ? tempFileNameList : [tempFileNameList]).map(fileName => fileName)
        }
      }
      await Vue.httpClient.post('/api/purchase/customerCare/atmMntcHstrInsert', { ...this.mntcData, mobile: 'mobile' }).then((response) => {
        if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
          const atmWsParams = {
            atmId: this.mntcData.atmId,
            jobDvsnCode: 'mntc_req'
          }
          window.$store.dispatch('AtmWsStore/noticeToAtm', atmWsParams)
            .then(res => {
              if (res.status === 200 && res.data.status === '200' && res.data.result === 200) {
                this.$Alert.alert('유지보수 내용이 저장되었습니다.').then(() => {
                  this.$router.push({name: 'AtmMntcSchd', params: { doShowModal: true }})
                })
              }
            })
        }
      })
    },
    obstVaildationCheck () {
      if (!this.obstData.atmNum) {
        window.$Alert.alert('COM 번호를 확인해 주세요.')
        return false
      }
      // [2023.01.09] [BOS-197] BOS 장애등록 개선 요청 by 류종직 (김철호 요청)
      // 일시정지 및 장애로 되어있더라도 처리되도록 수정
      /*
      if (this.obstData.atmStatCd !== '1') {
        window.$Alert.alert('장애신고는 ATM상태가 정상이면 가능합니다.')
        return false
      }
      */

      if (!this.obstData.atmObstTypeCd) {
        window.$Alert.alert('장애유형을 선택하세요.')
        return false
      }
      if (!this.obstData.atmObstCtts) {
        window.$Alert.alert('장애내용을 입력하세요.')
        return false
      }
      return true
    },

    async obstSave () {
      if (!this.obstVaildationCheck()) return

      const confirm = await this.$Alert.confirm('저장 하시겠습니까?')
      if (!confirm) return

      if (this.obstFile) {
        await this.upload(this.obstFile)
      }

      Vue.httpClient.post('/api/purchase/customerCare/atmObstHstrInsert', {...this.obstData})
        .then((response) => {
          if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            this.$router.push({name: 'AtmObstHstr', params: { }})
          }
        })
    },
    async mntcObstSave () {
      if (!this.mntcVaildationCheck()) return
      if (!this.obstVaildationCheck()) return

      if (this.mntcFiles && this.mntcFiles.length > 0) {
        await this.upload(this.mntcFiles)
      }
      await Vue.httpClient.post('/api/purchase/customerCare/atmMntcHstrInsert', { ...this.mntcData }).then((response) => {
        if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
          Vue.httpClient.post('/api/purchase/customerCare/atmObstHstrInsert', {...this.obstData})
            .then((response) => {
              if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
                this.gotoatmMntcHstr()
              }
            })
        }
      })
    },
    gotoatmMntcHstr () {
      this.$router.push({name: 'AtmMntcHstr'})
    },
    // 아래의 async를 넣지 않으면 에러발생 - 사용하는 장애유형 조회하기
    async setCommCodeByAtmObstTypeCds () {
      const params = {}
      const response = await Vue.httpClient.post('/api/purchase/customerCare/atmObstTypeMngtUseList', params)
      const codeList = []

      if (response && response.data && response.data.result) {
        response.data.result.forEach(c => {
          codeList.push({
            cmnsCd: c.atmObstTypeCd,
            cmnsCdNm: c.atmObstTypeNm,
            guidCtts: c.guidCtts
          })
        })
      }
      this.atmObstTypeCds = [...codeList]
      this.obstData.atmObstTypeCd = ''
    },
    init () {
      this.mntcData = {
        prchChnlAfliNum: '',
        atmInfo: '',
        atmNum: '',
        atmDvsnCd: '',
        atmMntcSchdNum: '',
        extlChckStatCd: '',
        cmraExtlChckStatCd: '',
        cablChckStatCd: false,
        cb5pChckStatCd: false,
        cb8pChckStatCd: false,
        cbctChckStatCd: false,
        mntcFileNameList: [],
        atmMntcPecuCd: '',
        atmMntcDtlLoc: '',
        regDt: moment().format('yyyy-MM-DD'),
        atmMntcPecuCtts: '',
        atmMntcDtlLocCtts: ''
      }

      this.obstData = {
        atmNum: '',
        atmStatCd: '',
        atmObstTypeCd: '',
        atmObstStatCd: '',
        atmObstRegCd: '2',
        atmObstCtts: '',
        obstFileNm: '',
        wrkwDvsnCd: '10'
      }

      this.mntcFiles = []
      this.obstFile = null
    },
    async getCommCdList (cmnsCdGrpId) {
      const params = { cmnsCdGrpId }
      const res = await this.$http.get('/api/appmgmt/common/code/list', {params, data: {isLoadingHide: 'Y'}})

      if (res) {
        const { data: { result } } = res
        return result
      }
      return []
    },
    cameraJobDone (files) {
      this.mntcFiles = []
      this.mntcData.mntcFileNameList = []
      for (let file of files) {
        console.log('>>>> > file: AtmMntcHstrInsert.vue:797 > cameraJobDone > file', file)
        this.mntcFiles.push(file)
        this.mntcData.mntcFileNameList.push(file.name)
      }
    }
  },
  async created () {
    console.log('>>>> > file: AtmMntcHstrInsert.vue:622 > created > created')
    // 초기화 작업
    this.init()

    this.atmMntcPecuCdList = await this.getCommCdList('ATM_MNTC_PECU_CD')
    this.atmMntcDtlLocList = await this.getCommCdList('ATM_MNTC_DTL_LOC')

    if (!isEmpty(this.getStoreAtmInfo)) {
      const sai = this.getStoreAtmInfo
      this.mntcData = {
        ...this.mntcData,
        prchChnlAfliNum: sai.com_num
      }

      this.findAtmInfo()
    }
  },
  async mounted () {
    console.log('>>>> > file: AtmMntcHstrInsert.vue:637 > mounted > mounted')
    // 장애유형 조회하기
    await this.setCommCodeByAtmObstTypeCds()

    await this.$nextTick()
  }
}
</script>

<style scoped>
.main .quick-link {
  height: 150px;
}
.icon_require:before{content: '*'; display: inline-block; margin-right: 2px; font-weight: 700;}
</style>



// WEBPACK FOOTER //
// src/views/customerCare/AtmMntcHstrInsert.vue